import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  lrn: string;
  batchName: string;
  regulate?: boolean;
}

export const useGenerateBatchByLrn = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ lrn, batchName, regulate = false }: HookProps) => {
      await request({
        path: `declarations/${lrn}/generate-batch-by-lrn`,
        method: 'POST',
        authenticate: true,
        dataObject: { batchName, regulate },
      });
    },
    onSuccess: (_, variables) => {
      // todo: figure out why it takes 5s for the retrieve to return the added values as well
      setTimeout(() => {
        queryClient.invalidateQueries({ queryKey: ['batch'] });
        queryClient.invalidateQueries({ queryKey: ['declarations'] });
        queryClient.invalidateQueries({ queryKey: ['declarations-meta'] });
        toast.success(variables.regulate ? 'Regularisation done!' : 'Duplication done!');
      }, 5000);
      queryClient.invalidateQueries({ queryKey: ['declaration'] });
    },
    onError: (error, variables) => {
      showErrorToast(error, variables.regulate ? `Couldn't regulate!` : `Couldn't duplicate!`);
    },
  });
};
